module.exports = __webpack_public_path__ + "img/kings-logo.3a0a7090.jpg";